import React from 'react';
import sun_emoji from '../../assets/images/sun_emoji.svg';



const SummerPrograms = ({ onRegisterClick }) => {
  const programs = [
    {
      title: "Advanced Foundation",
      target: "Class 1-10",
      desc: "IIT/NEET Foundation, Olympiad, Civil Services Prep, and Advanced Mathematics."
    },
    {
      title: "Basic Foundation",
      target: "Class 1-10",
      desc: "Math, Physics, Chemistry, Biology, MAT (IQ), and Languages (TE/HI/EN)."
    },
    {
      title: "Intermediate IIT-Foundation",
      target: "10th Passed",
      desc: "Strong MPC foundation and Bridge for JEE/NEET. Aim for IIT excellence."
    },
    {
      title: "10th Class Bridge",
      target: "9th Completed",
      desc: "40-Day Intensive Syllabus Completion for both SSC and CBSE boards."
    },
    {
      title: "Skill Oriented Courses",
      target: "Class 1-10",
      desc: "Coding in 'C', Spoken English, Calligraphy, Speed Maths, and Personality Dev."
    }
  ];

  return (
    <section className="programs-section" id="courses">
      <div className="container">
        <h2 className="section-heading">Our Summer Tracks</h2>
        <div className="programs-grid">
          {programs.map((item, index) => (
            <div key={index} className="program-card">
              <span className="target-tag">{item.target}</span>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
        <div className="programs-cta">
          <button className="btn-register-lg" onClick={onRegisterClick}>
            Register Now for Summer Camp
          </button>
        </div>
      </div>
      <div className='section-img-holder'>
          <img src={sun_emoji} className='sun-emoji' alt='narayana tuitions summer camp' />
      </div>
    </section>
  );
};

export default SummerPrograms;